"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var dx_react_grid_1 = require("@devexpress/dx-react-grid");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var officesList_1 = require("common/global/officesList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var app_1 = __importDefault(require("firebase/app"));
var moment_1 = __importDefault(require("moment"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("../../utils/defaultDevExtremeGridComponents"));
var hasProjectPermission_1 = require("../Projects/hasProjectPermission");
var permissiontypes_1 = require("../Tables/Users/permissiontypes");
var AddProcurementPlanItem_1 = __importDefault(require("./Dialogs/AddProcurementPlanItem"));
var EditProcurementPlanItem_1 = __importDefault(require("./Dialogs/EditProcurementPlanItem"));
var react_router_dom_1 = require("react-router-dom");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
function ProcurementPlanComp() {
    var _this = this;
    var _a, _b;
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t("budget.procurementPlan"));
    var params = (0, react_router_dom_1.useParams)();
    var projectId = params.projectId;
    var _c = (0, react_1.useState)(false), modalState = _c[0], setModalState = _c[1];
    var _d = (0, react_1.useState)(false), editModalState = _d[0], setEditModalState = _d[1];
    var _e = (0, react_1.useState)(undefined), rowId = _e[0], setRowId = _e[1];
    var _f = (0, react_1.useState)(false), tableSelection = _f[0], setTableSelection = _f[1];
    var _g = (0, react_1.useState)(true), deleteStatus = _g[0], setDeleteStatus = _g[1];
    var _h = (0, react_1.useState)([]), selectedRows = _h[0], setSelectedRows = _h[1];
    var _j = (0, react_1.useState)(false), createIRLoading = _j[0], setCreateIRLoading = _j[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var userId = app_1.default.auth().currentUser.uid;
    var _k = (0, firestore_1.useDocument)(collectionsRef_1.projectsRef.doc(projectId)), projectSN = _k[0], loading = _k[1];
    var procurementPlanSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.procurementPlansRef.where("projectId", "==", projectId))[0];
    var dataSource = (0, react_1.useMemo)(function () {
        var _a;
        return ((_a = procurementPlanSnapshot === null || procurementPlanSnapshot === void 0 ? void 0 : procurementPlanSnapshot.docs) !== null && _a !== void 0 ? _a : []).map(function (doc) {
            return __assign(__assign({}, doc.data()), { id: doc.id });
        });
    }, [procurementPlanSnapshot]);
    var deletePlanRecord = function (id, rowQuantity, budgetLineItemId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            collectionsRef_1.budgetLineItemsRef
                .doc(budgetLineItemId)
                .update({
                plannedQuantity: app_1.default.firestore.FieldValue.increment(-rowQuantity),
            })
                .then(function () { var _a; return (_a = collectionsRef_1.procurementPlansRef === null || collectionsRef_1.procurementPlansRef === void 0 ? void 0 : collectionsRef_1.procurementPlansRef.doc(id)) === null || _a === void 0 ? void 0 : _a.delete(); })
                .then(function () {
                setDeleteStatus(true);
            });
            return [2 /*return*/];
        });
    }); };
    var columns = [
        { name: "productType", title: "Type" },
        {
            name: "projectCode",
            title: "Project Code",
            getCellValue: function (r) { var _a; return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.code; },
        },
        {
            name: "officeId",
            title: "Office Site",
            getCellValue: function (r) { var _a; return (_a = officesList_1.globalOfficesData[r.officeId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        { name: "officeType", title: "Office Type" },
        { name: "itemDescription", title: "Item Description" },
        {
            name: "unit",
            title: "Unit",
            getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.unitId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        { name: "quantity", title: "Quantity" },
        { name: "unitCost", title: "Unit Price" },
        { name: "totalCost", title: "Total Price" },
        {
            name: "requiredDateToDelivery",
            title: "Required Delivery Date",
            getCellValue: function (r) {
                return r.requiredDateToDelivery.toDate().toLocaleDateString();
            },
        },
        {
            name: "IRRising",
            title: "IR Raising",
            getCellValue: function (r) {
                return r.IRRising.toDate().toLocaleDateString();
            },
        },
        {
            name: "expectedDateToDelivery",
            title: "Expected Delivery Date",
            getCellValue: function (r) {
                return r.expectedDateToDelivery.toDate().toLocaleDateString();
            },
        },
        {
            name: "user",
            title: "Person In Charge",
            getCellValue: function (r) { var _a; return (_a = usersList_1.globalUsersData[r.userId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "id",
            title: "Actions",
            key: "id",
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                var _this = this;
                return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, permissiontypes_1.permissionTypes)("deleteProcurementPlan", currentUser.permissions) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ disabled: !deleteStatus, type: "link", size: "small", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                setDeleteStatus(false);
                                                return [4 /*yield*/, deletePlanRecord(row.id, row.quantity, row.budgetLineItemId)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }, { children: t("common.delete") }))) : null })), (0, jsx_runtime_1.jsx)("span", { children: (0, permissiontypes_1.permissionTypes)("editProcurementPlan", currentUser.permissions) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "link", size: "small", onClick: function () {
                                    setRowId(row.id);
                                    setEditModalState(true);
                                } }, { children: t("common.edit") }))) : null })] }));
            },
        },
    ];
    function insertIRItems(IRId) {
        return __awaiter(this, void 0, void 0, function () {
            var orderCreate, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, collectionsRef_1.ordersRef.add({
                                projectId: projectId,
                                status: "preparingIR",
                                IRId: IRId,
                                createdAt: new Date(),
                            })];
                    case 1:
                        orderCreate = _a.sent();
                        return [4 /*yield*/, collectionsRef_1.IRsRef.doc(IRId).set({
                                status: "draft",
                                projectId: projectSN.id,
                                createdAt: new Date(),
                                initiatedBy: userId,
                                orderId: orderCreate.id,
                                description: "",
                                exchangeRate: 0,
                                totalEstimatedCostInUsd: 0,
                                totalEstimatedCostInLocalCurrency: 0,
                                // IRNo: lastSerial + 1,
                                // ref: `${dateOfNow}-${lastSerial + 1}`,
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(dataSource.map(function (procurementPlanItem) {
                                if (!selectedRows.includes(procurementPlanItem.id)) {
                                    return;
                                }
                                return collectionsRef_1.IRItemsRef.add({
                                    IRId: IRId,
                                    productId: procurementPlanItem.productId,
                                    productName: procurementPlanItem.productName,
                                    productDescription: procurementPlanItem.productDescription,
                                    quantity: procurementPlanItem.quantity,
                                    estimatedPrice: procurementPlanItem.unitCost,
                                    requiredDeliveryDate: new Date(),
                                    budgetLineId: procurementPlanItem.budgetLineId,
                                    budgetLineItemId: procurementPlanItem.budgetLineItemId,
                                    createdAt: new Date(),
                                });
                            }))];
                    case 3:
                        _a.sent();
                        navigate("/internal-requests/".concat(IRId));
                        antd_1.message.success(t("alerts.success"));
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        antd_1.message.success(t("alerts.error"));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(AddProcurementPlanItem_1.default, { projectId: projectId, modalState: modalState, setModalState: setModalState, docId: "notFromBudget" }), editModalState ? ((0, jsx_runtime_1.jsx)(EditProcurementPlanItem_1.default, { projectId: projectId, modalState: editModalState, setModalState: setEditModalState, rowId: rowId !== null && rowId !== void 0 ? rowId : "" })) : null, (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.buttonsGroup }, { children: [(0, permissiontypes_1.permissionTypes)("setupProcurementPlan", currentUser.permissions) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", shape: "circle", size: "large", onClick: function () {
                                    setModalState(true);
                                } }, { children: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}) }))) : null, (0, hasProjectPermission_1.hasProjectPermission)(projectId, ["IRCreate"]) &&
                                ((_a = projectsList_1.globalProjectsData[projectId]) === null || _a === void 0 ? void 0 : _a.endingDate.toDate()) >
                                    (0, moment_1.default)().toDate() &&
                                ((_b = projectsList_1.globalProjectsData[projectId]) === null || _b === void 0 ? void 0 : _b.status) === "running" ? ((0, jsx_runtime_1.jsxs)(antd_1.Button, __assign({ onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var IRId;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                IRId = collectionsRef_1.IRsRef.doc().id;
                                                setCreateIRLoading(true);
                                                return [4 /*yield*/, insertIRItems(IRId).then(function () {
                                                        setCreateIRLoading(false);
                                                        navigate("/internal-requests/".concat(IRId));
                                                    })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }, { children: [createIRLoading ? ((0, jsx_runtime_1.jsx)(antd_1.Spin, { indicator: (0, jsx_runtime_1.jsx)(icons_1.LoadingOutlined, { style: { fontSize: 18, marginRight: 18 }, spin: true }) })) : null, t("budget.createIR")] }))) : null] })), (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns, getRowId: function (r) { return r.id; } }, { children: __spreadArray([(0, jsx_runtime_1.jsx)(dx_react_grid_1.SelectionState, { onSelectionChange: function (e) {
                                    e.length > 0 ? setTableSelection(true) : setTableSelection(false);
                                    setSelectedRows(e.map(function (e) { return e.toString(); }));
                                } })], (0, defaultDevExtremeGridComponents_1.default)({ withSelection: true }), true) }))] })] }));
}
exports.default = ProcurementPlanComp;
